// extracted by mini-css-extract-plugin
module.exports = {"widget-calendar":"overrides_widget-calendar__eu9fN"};